import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';

@Directive({
  selector: '[appPasswordComplexity]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PasswordComplexityDirective,
      multi: true,
    },
  ],
})
export class PasswordComplexityDirective {
  // ref: https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
  // @#$%^&*-_!+=[]{}|\：'，。?/`~"();<>
  // 大小寫字母、數字、特殊符號
  regxString =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[@#\$%\^\&*\)\(!+=._-]).{8,256}$/;
  constructor() {}
  validate(control: AbstractControl): ValidationErrors | null {
    return control.value
      ? passwordComplexityValidator(this.regxString)(control)
      : null;
  }
}

export function passwordComplexityValidator(passReg: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const regResult = passReg.test(control.value)
      ? null
      : { passwordComplixity: true };
    return regResult;
  };
}
